export class TransactionDetail {
    /** Name */
    name: string = "";

    /** Amount */
    amount: number = 0;

    /** Currency */
    currency: string = "";

    public parse(obj: any) {
        if (obj.Name) this.name = obj.Name;
        if (obj.Amount) this.amount = obj.Amount;
        if (obj.Currency) this.currency = obj.Currency;
    }
}
